<!-- Generic button that indicates some sort of async action will be performed and the user should wait for it to finish -->
<template>
    <q-btn
        color="accent"
        type="button"
        :disable="isProcessingAction || busy"
        :label="isProcessingAction || busy ? busyLabel : label"
        no-caps
        @click="onClick"
    >
        <q-inner-loading :showing="isProcessingAction || busy">
            <q-spinner size="30px" color="white" />
        </q-inner-loading>
    </q-btn>
</template>

<script setup>
import { trackBusyState } from 'src/utils/misc.js'
import { ref } from 'vue'

const props = defineProps({
    action: Function, // Callback function to do the action (should return an async/promise)

    label: {
        type: String,
        default: 'Action Name',
    },

    busyLabel: {
        type: String,
        default: 'Please wait...',
    },

    busy: Boolean, // Externally set busy state of this button?
})

const isProcessingAction = ref()

function onClick() {
    return trackBusyState(isProcessingAction, () => props.action())
}
</script>
